import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AveriasService } from '../servicios/averias.service';
import { Area } from "../entidades/entidades.component";
import { UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { NbCheckboxModule } from '@nebular/theme';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
@Component({
    selector: 'app-area',
    templateUrl: './area.component.html',
    styleUrls: ['./area.component.css'],
    standalone: true,
    imports: [FormsModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule,
       MatFormFieldModule, MatInputModule, SpinnerComponent, AngularSlickgridModule, NbTabsetModule
      , AgGridAngular,NbCheckboxModule],
     providers: [DatePipe],
    
})
export class AreaComponent implements OnInit {
  durationInSeconds = 3;
  eliminar = false;
  area: SelectItem[];
  areaOK = false;
  IdArea: number;
  showArea = false
  areaProcesada;
  firstForm: UntypedFormGroup;
  descripcionArea;
  descripcionAreaEditar;
  descripcionBreve;
  descripcionBreveEditar;
  codigoExterno;
  codigoExternoEditar;
  areaCompleta;
  name = new UntypedFormControl('');
  idCliente: number;
  datasetArea: any[] = [];
  datasetAreaConsulta: any[] = [];
  angularGridArea: AngularGridInstance;
  angularGridAreaConsulta: AngularGridInstance;
  angularGridAreaModificar: AngularGridInstance;
  showSpinner = false;
  columnDefinitionsArea: Column[];
  gridOptionsArea: GridOption;
  
  //columnDefinitionsAreaConsulta: Column[];
   columnDefinitionsAreaConsulta:  ColDef[];

  gridOptionsAreaConsulta: GridOption;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  showSpinnerConsulta = false;
  showAreaConsulta = false;
  showAreaModificar = false;
  showSpinnerModificarGrilla = false;
  columnDefinitionsAreaModificar: Column[];
  gridOptionsAreaModificar: GridOption;
  datasetAreaModificar: any[] = [];
  eliminarSeleccionado;
  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.svcAnalytics.setAnalyticsPageView();
  }
  ngAfterViewInit():void {
    
  }  
  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarArea();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarAreaConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarAreaModificar();
    }
  }
  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarArea() {
    this.showSpinner = true;
    this.showArea = false;
    this.AveriasService.getArea(this.idCliente).subscribe(
      data => {
        this.areaCompleta = data;
        this.area = this.insertarArea(data);
        this.traerDatosArea();
        this.fillGrillaArea();
    });
  }
  consultarAreaConsulta() {
    this.showSpinnerConsulta = true;
    this.showAreaConsulta = false;
    this.AveriasService.getArea(this.idCliente).subscribe(
      data => {
        this.areaCompleta = data;
        this.traerDatosAreaConsulta();
        this.fillGrillaAreaConsulta();
      });
  }
  consultarAreaModificar() {
    this.showSpinnerModificarGrilla = true;
    this.showAreaModificar = false
    this.AveriasService.getArea(this.idCliente).subscribe(
      data => {
        this.areaCompleta = data;
        this.area = this.insertarArea(data);
        this.traerDatosAreaModificar();
        this.fillGrillaAreaModificar();
      });
  }
  insertarArea(armarArea) {
    let averiasArea: Array<any> = [];
    armarArea.content.forEach(element => {
      averiasArea.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasArea;
  };
  capturarArea(event) {
    this.IdArea = event;
    this.areaOK = true;
  }
  altaArea() {
    let area: Area;

    if (this.descripcionArea == null || this.descripcionArea == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe completar el Código Externo ❌");
    } else {
      area = {
        descripcion: this.descripcionArea,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        idCliente: this.idCliente,

      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postArea(area).subscribe(data => {
        if (data["status"] == 201) {
          this.openSnackBar('Los cambios se han guardado correctamente');
           //gtag boton de alta
           this.svcAnalytics.setAnalyticsAltaButton();
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.descripcionArea = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.consultarArea();
        this.showSpinnerGuardar = false;
      })
    }
  }
  modificarArea() {
    let area: Area;
    if (this.eliminar) {
      this.AveriasService.deleteArea(this.areaProcesada).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionAreaEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.areaProcesada = '';
          //gtag de Baja
          this.svcAnalytics.setAnalyticsBajaButton();
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.consultarAreaModificar();
        this.eliminar = false;
        this.eliminarSeleccionado = false;
      })
    } else {

      if (this.descripcionAreaEditar == null || this.descripcionAreaEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        area = {
          descripcion: this.descripcionAreaEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          idCliente: this.idCliente,
        }
        this.AveriasService.putArea(this.areaProcesada, area).subscribe(data => {
          if (data["status"] == 200) {
            this.openSnackBar('Los cambios se han guardado correctamente');   
            //gtag de Modificacion
            this.svcAnalytics.setAnalyticsModificacionButton();         
          } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
          this.showSpinnerModificar = false;
          this.eliminar = false;
          this.eliminarSeleccionado = false;
          this.consultarAreaModificar();
        })
        this.descripcionAreaEditar = '';
        this.descripcionBreveEditar = '';
        this.codigoExternoEditar = '';
        this.areaProcesada = '';
        this.eliminarSeleccionado = false;
        this.eliminar = false;
      }
    }
  }
  obtenerDescripcionDropdown(IdArea: number) {
    let resp = this.areaCompleta.content.find(n => n['id'] == IdArea);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionAreaEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.eliminarSeleccionado = false;
  }
  //Grilla Area
  traerDatosArea() {
    let DatosArea = this.areaCompleta['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosArea.length; i++) {
      mockDataset.push({
        id: DatosArea[i]["id"],
        Descripcion: DatosArea[i]["descripcion"],
        DescripcionAbreviada: DatosArea[i].descripcionAbreviada,
        Codigo: DatosArea[i]["codigoExterno"],
      });
    }
   
    this.datasetArea = mockDataset;
    this.showSpinner = false;
    this.showArea = true;
   
  }

  onGridReady(params: GridReadyEvent): void {
   // this.gridApi = params.api;
 //   this.gridColumnApi = params.columnApi;
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }

  traerDatosAreaConsulta() {
    let DatosArea = this.areaCompleta['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosArea.length; i++) {
      mockDataset.push({
        id: DatosArea[i]["id"],
        Descripcion: DatosArea[i]["descripcion"],
        DescripcionAbreviada: DatosArea[i].descripcionAbreviada,
        Codigo: DatosArea[i]["codigoExterno"],
      });
    }
    this.datasetAreaConsulta = mockDataset;
    this.showSpinnerConsulta = false;
    this.showAreaConsulta = true;
  }
  traerDatosAreaModificar() {
    let DatosArea = this.areaCompleta['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosArea.length; i++) {
      mockDataset.push({
        id: DatosArea[i]["id"],
        Descripcion: DatosArea[i]["descripcion"],
        DescripcionAbreviada: DatosArea[i].descripcionAbreviada,
        Codigo: DatosArea[i]["codigoExterno"],
      });
    }
    this.datasetAreaModificar = mockDataset;
    this.showSpinnerModificarGrilla = false;
    this.showAreaModificar = true;
  }
  fillGrillaArea() {
    this.columnDefinitionsArea = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 120, width: 120, },
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 120, width: 120, },
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 80, width: 80, },
    ];
    this.gridOptionsArea = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  fillGrillaAreaConsulta() {
    this.columnDefinitionsAreaConsulta = [
      {  headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 80, width: 80, },
    ];
    this.gridOptionsAreaConsulta = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  fillGrillaAreaModificar() {
    this.columnDefinitionsAreaModificar = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 120, width: 120, },
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 120, width: 120, },
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 80, width: 80, },
    ];
    this.gridOptionsAreaModificar = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  angularGridReadyArea(angularGrid: AngularGridInstance) {
    this.angularGridArea = angularGrid;
    this.angularGridArea.resizerService.pauseResizer(false)
  }
  angularGridReadyAreaConsulta(angularGrid: AngularGridInstance) {
    this.angularGridAreaConsulta = angularGrid;
    this.angularGridAreaConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadyAreaModificar(angularGrid: AngularGridInstance) {
    this.angularGridAreaModificar = angularGrid;
    this.angularGridAreaModificar.resizerService.pauseResizer(false)
  }

  exportToExcelArea() {
    // this.angularGridAreaConsulta.excelExportService.exportToExcel({
    //   filename: 'Área_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
    //   format: FileType.xlsx
    // });

    // (this.angularGridAreaConsulta as any).excelExportService.exportToExcel({
    //   filename: 'Área_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy'),
    //   format: FileType.xlsx
    // });

    this.exportToExcelConXLSX();
    //gtag de reporte excel
    this.svcAnalytics.setAnalyticsExcelButton();
  }

    exportToExcelConXLSX(): void {
      const rowData: any[] = [];
     const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
    
      // Obtener solo las filas visibles (después de filtros y orden)
      this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
        if (node.data) {
          const filaFiltrada: any = {};
    
          // Solo columnas visibles
          columnasVisibles.forEach(col => {
            const campo = col.getColDef().field;
            if (campo && campo!='action') {
              filaFiltrada[campo] = node.data[campo];
            }
          });
          rowData.push(filaFiltrada);
        }
      });
    
      if (rowData.length === 0) {
        console.warn('No hay datos para exportar');
        return;
      }
    
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Area': worksheet },
        SheetNames: ['Area']
      };
    
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
    
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, 'Área_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
    }
    

}
